import React, {forwardRef} from "react";
import classNames from "classnames";

import {FieldWrapper, IFieldWrapperProps} from "../../../atoms/wrapper/FieldWrapper";
import {IMaxValueInputProps} from "../../../types/IMaxValueInputProps";
import {getErrorMessage} from "../../../utils/get_error_message";
import {MaxValueInput} from "../../max_value_input/MaxValueInput";

import * as cns from "./MaxValueField.module.css";

type IProps = Omit<IFieldWrapperProps, "htmlFor" | "onClick"> &
    IMaxValueInputProps & {
        error?: string | string[];
    };

export const MaxValueField = forwardRef<HTMLInputElement, IProps>((props, inputForwardedRef) => {
    const {labelContent, message, id, className, fieldState, required, error, ...inputProps} = props;
    const errorMessage = getErrorMessage(error);

    return (
        <FieldWrapper
            labelContent={labelContent}
            fieldState={fieldState}
            message={errorMessage || message}
            htmlFor={id}
            className={classNames(cns.maxValueField, className)}
            required={required}
        >
            <MaxValueInput ref={inputForwardedRef} id={id} fieldState={fieldState} {...inputProps} />
        </FieldWrapper>
    );
});
import React, {forwardRef} from "react";
import classNames from "classnames";

import {FieldWrapper, IFieldWrapperProps} from "../../../atoms/wrapper/FieldWrapper";
import {IMaxValueInputProps} from "../../../types/IMaxValueInputProps";
import {getErrorMessage} from "../../../utils/get_error_message";
import {MaxValueInput} from "../../max_value_input/MaxValueInput";

import * as cns from "./MaxValueField.module.css";

type IProps = Omit<IFieldWrapperProps, "htmlFor" | "onClick"> &
    IMaxValueInputProps & {
        error?: string | string[];
    };

export const MaxValueField = forwardRef<HTMLInputElement, IProps>((props, inputForwardedRef) => {
    const {labelContent, message, id, className, fieldState, required, error, ...inputProps} = props;
    const errorMessage = getErrorMessage(error);

    return (
        <FieldWrapper
            labelContent={labelContent}
            fieldState={fieldState}
            message={errorMessage || message}
            htmlFor={id}
            className={classNames(cns.maxValueField, className)}
            required={required}
        >
            <MaxValueInput ref={inputForwardedRef} id={id} fieldState={fieldState} {...inputProps} />
        </FieldWrapper>
    );
});
